import { cn } from "lib/utils";

export const FinanceSideNav = ({ paymentMethod, handleBack }) => {
    return (
        <aside className="md:w-[300px] w-full bg-grey-bg md:h-full p-4">
            <div className="flex items-start justify-start h-full gap-2 pl-5">
                <div className="flex flex-col items-center justify-center w-min">
                    <div
                        className={cn(
                            "flex items-center justify-center rounded-full text-base size-6 text-white font-[450]",
                            paymentMethod ? "!bg-secondary" : "bg-gray-80"
                        )}
                    >
                        1
                    </div>
                    <div className="self-center w-[2px] h-[24px] border-2 bg-gray-80 " />
                    <div className="flex items-center justify-center rounded-full text-base size-6 text-white font-[450] bg-gray-80">
                        2
                    </div>
                </div>
                <div className="flex flex-col items-center justify-center">
                    <p
                        className={cn(
                            "flex items-center justify-center h-6 cursor-pointer text-xs font-[450] rounded-full !text-secondary"
                        )}
                        onClick={handleBack}
                    >
                        Choose category
                    </p>
                    <div className="self-center w-[2px] h-[24px] border-2 " />
                    <div
                        className={cn(
                            "flex items-center justify-center h-6 text-xs font-[450] rounded-full",
                            paymentMethod ? "!text-secondary" : "text-gray-80"
                        )}
                    >
                        Complete details
                    </div>
                </div>
            </div>
        </aside>
    );
};

export default FinanceSideNav